import { useNavigate, useParams } from '@exam-management/router';
import { Button, DescriptionOutlinedIcon } from '@shared/components';
import { matchPath, useLocation } from 'react-router-dom';

export default function QuestionReviewButton() {
  const location = useLocation();
  const matchedTaskManagement = matchPath(
    '/task-management/qset-review/:taskId/*',
    location.pathname,
  );
  const paramPath = matchedTaskManagement
    ? '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details'
    : '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details';
  const { taskId, subTaskId } = useParams(paramPath);

  const navigate = useNavigate();

  const handleClick = () => {
    const paramPath = matchedTaskManagement
      ? '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details'
      : '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details';
    navigate(paramPath, {
      replace: true,
      params: {
        taskId: taskId ?? '',
        subTaskId: subTaskId ?? '',
      },
    });
  };

  return (
    <Button startIcon={<DescriptionOutlinedIcon />} onClick={handleClick}>
      Question Review
    </Button>
  );
}
